import React, { useEffect } from 'react'

export default function PasswordChecklist({ password, setIsValid }) {

  useEffect(() => {
    let valid = false
    if (
      requirementLength() &&
      requirementNumber() &&
      requirementUppercase() &&
      requirementSpecialCharacter()
    ) {
      valid = true
    }
    setIsValid(valid)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [password])

  const requirementLength = () => {
    const requirement = /^(?=.{8,})/
    return requirement.test(password)
  }

  const requirementUppercase = () => {
    const requirement = /^(?=.*[A-Z])/
    return requirement.test(password)
  }

  const requirementNumber = () => {
    const requirement = /^(?=.*[0-9])/
    return requirement.test(password)
  }

  const requirementSpecialCharacter = () => {
    const requirement = /^(?=.*[!@#$%^&*])/
    return requirement.test(password)
  }

  return (
    <div className='text-muted'>
      <small>
        <ul className='pl-3'>
        <li className='list-unstyled my-2'> 
            <span
              className={`${
                requirementLength() ? 'text-success' : ''
              }`}
            >
              8 characters long
            </span>
          </li>
          <li className='list-unstyled my-2'> 
            <span
              className={`${
                requirementUppercase() ? 'text-success' : ''
              }`}
            >
              include an uppercase letter
            </span>{' '}
            (A-Z)
          </li>
          <li className='list-unstyled my-2'> 
            <span
              className={`${
                requirementNumber() ? 'text-success' : ''
              }`}
            >
              include a number
            </span>{' '}
            (0-9)
          </li>
          <li className='list-unstyled my-2'> 
            <span
              className={`${
                requirementSpecialCharacter() ? 'text-success' : ''
              }`}
            >
              a special character
            </span>{' '}
            (!, @, #, $, %, ^, &, *)
          </li>
        </ul>
      </small>
    </div>
  )
}
